import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const divisionsTableTooltips = TOOLTIPS_TEXTS.divisionsTable;

export const DIVISIONS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'sync', src: 'icons/recycle' },
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'duplicate', src: 'icons/duplicate' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const DIVISIONS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const DIVISIONS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'city', 'state', 'phone', 'options'],
  displayedTitles: ['Name', 'City', 'State/Province', 'Phone', 'Actions'],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    divisionsTableTooltips.name,
    divisionsTableTooltips.city,
    divisionsTableTooltips.state,
    divisionsTableTooltips.phone
  ],
  optionsPerRow: null,
  options: null,
  dataSource: []
};
